import namespace from '@/store/namespace'
export default namespace('DesistimientoRenuncia',{
    getters:[
        'GetDatosDesistimientoPe',
        //'GetlugarDesarrollo',
        //'Getpromociones',
        //'GetPromocionesEnviadasNetTodos',
        'GetDesistimientosNet',
        'GetDesistimientosAmplNet'
    ],
    actions:[
        'RegistrarDesistimiento',
        'ModificarDesistimiento',
        'ObtenerDesistimiento',
        //'ObtenerPromocionesTodosNet',
        'ObtenerDesistimientosRenunciasNet',
        'ObtenerDesistimientosRenunciasAmplNet',
        'EliminarSolicitudDesistimiento',
        'EnviarSolicitudDesistimiento',
        'ObtenerDocumentoBorrador'
    ],
    mutations:[
        'SetDatosDesistimientoPe',
        //'SetlugarDesarrollo',
        //'Setpromociones',
        //'SetPromocionesEnviadasNetTodos',
        'SetDesistimientosRenunciasNet',
        'SetDesistimientosRenunciasAmplNet'
    ]
})
